import {get, patch, post, put, del} from "./fetch";

export const sendCapcha = async (capcha: string): Promise<any> => {
  try {
    const response = await post('/user/capcha', {capcha});
    return response as any;
  } catch (error) {
    throw new Error('Error occurred during login');
  }
};

export const userDataRequest = async (): Promise<any> => {
  return await get('/user/data');
};

export const userList = async (): Promise<any> => {
  try {
    return await get('/user/list');
  } catch (error) {
    throw new Error('Error occurred while fetching material');
  }
};

export const changeUserState = async (userId: number, stateId: number): Promise<boolean> => {
  return patch(`/user/updateState/${userId}`, { stateId });
};

export const changeAccessUserPart = async (userId: number, accessUserPart: boolean): Promise<boolean> => {
  return get(`/user/changeAccessUserPart?userId=${userId}&accessUserPart=${accessUserPart}`);
};

export const changeUserStatus = async (userId: number, newStatus: string): Promise<boolean> => {
  return put(`/user/status`, { userId, newStatus });
};

export const changeUserPermissions = async (userId: number, newPermissions: Record<string, boolean> | null): Promise<boolean> => {
  return put(`/user/permissions`, { userId, newPermissions });
};

export const changeUserRole = async (userId: number, newRole: number): Promise<boolean> => {
  return put(`/user/role`, { userId, newRole });
};

export const deleteUser = async (id: number): Promise<void> => {
  return await del(`/user/delete/${id}`);
};